
export const landingPageConfig = {
  appMeta: {
    appName: "LearnZapp",
    baseUrl: "https://isc2.learnzapp.com",
    productLine: "ISC2",
    publisher: "LearnZapp",
    hubTitle: "ISC2 CISSP, CCSP, SSCP & CC Exam Prep | Official Study App - LearnZapp",
    hubDescription: "Prepare for ISC2 CISSP, CCSP, SSCP and CC certifications with 5000+ practice questions, 2000+ flashcards, and comprehensive study materials. Adaptive learning and detailed analytics.",
    hubMetaTitle: "ISC2 CISSP, CCSP, SSCP & CC Exam Prep | Official Study App",
    hubMetaDescription: "Prepare for ISC2 CISSP, CCSP, SSCP and CC certifications with 5000+ practice questions and 2000+ flashcards.",
    utmCampaign: "isc2-launch",
    ogImage: "/assets/images/og-image.png"
  },

  certSlugs: {
    cissp: "cissp",
    ccsp: "ccsp",
    sscp: "sscp",
    cc: "cc"
  },

  certMeta: {
    cissp: {
      pageTitle: "ISC2 CISSP Practice Test | Official Study Questions - LearnZapp",
      metaDescription: "Comprehensive CISSP practice questions covering all 8 domains. Security and Risk Management, Asset Security, Security Architecture, and more.",
      h1: "ISC2 CISSP Exam Prep"
    },
    ccsp: {
      pageTitle: "ISC2 CCSP Practice Test | Official Study Questions - LearnZapp",
      metaDescription: "Comprehensive CCSP practice questions covering all 6 domains. Cloud Concepts, Cloud Data Security, Cloud Platform & Infrastructure Security, and more.",
      h1: "ISC2 CCSP Exam Prep"
    },
    sscp: {
      pageTitle: "ISC2 SSCP Practice Test | Official Study Questions - LearnZapp",
      metaDescription: "Comprehensive SSCP practice questions covering all 7 domains. Access Controls, Security Operations, Risk Identification, and more.",
      h1: "ISC2 SSCP Exam Prep"
    },
    cc: {
      pageTitle: "ISC2 CC Practice Test | Certified in Cybersecurity Study Questions - LearnZapp",
      metaDescription: "Comprehensive ISC2 Certified in Cybersecurity (CC) practice questions covering all 5 domains. Security Principles, Security Governance, IAM Concepts, and more.",
      h1: "ISC2 CC Exam Prep"
    }
  },

  certFaqs: {
    cissp: [
      { question: "How many questions are on the CISSP exam?", answer: "The CISSP exam uses Computerized Adaptive Testing (CAT) with 100-150 questions. You have 3 hours to complete it. The exam adapts to your ability level as you answer questions." },
      { question: "What is the passing score for CISSP?", answer: "The passing score for the CISSP exam is 700 out of 1000 points." },
      { question: "What domains does CISSP cover?", answer: "CISSP covers 8 domains: Security and Risk Management, Asset Security, Security Architecture and Engineering, Communication and Network Security, Identity and Access Management, Security Assessment and Testing, Security Operations, and Software Development Security." },
      { question: "Is CISSP the hardest cybersecurity certification?", answer: "CISSP is considered one of the most challenging cybersecurity certifications. It requires a minimum of 5 years of cumulative paid work experience in two or more of the 8 domains. However, with proper preparation, many candidates pass on their first attempt." }
    ],
    ccsp: [
      { question: "How many questions are on the CCSP exam?", answer: "The CCSP exam has 150 multiple-choice questions. You have 4 hours to complete the exam." },
      { question: "What is the passing score for CCSP?", answer: "The passing score for the CCSP exam is 700 out of 1000 points." },
      { question: "What domains does CCSP cover?", answer: "CCSP covers 6 domains: Cloud Concepts, Architecture and Design; Cloud Data Security; Cloud Platform & Infrastructure Security; Cloud Application Security; Cloud Security Operations; and Legal, Risk and Compliance." },
      { question: "Do I need CISSP before taking CCSP?", answer: "No, CISSP is not a prerequisite for CCSP. However, CCSP requires a minimum of 5 years of cumulative paid work experience in IT, of which 3 years must be in information security and 1 year in one or more of the 6 CCSP domains." }
    ],
    sscp: [
      { question: "How many questions are on the SSCP exam?", answer: "The SSCP exam has 125 multiple-choice questions. You have 3 hours to complete the exam." },
      { question: "What is the passing score for SSCP?", answer: "The passing score for the SSCP exam is 700 out of 1000 points." },
      { question: "What domains does SSCP cover?", answer: "SSCP covers 7 domains: Access Controls, Security Operations and Administration, Risk Identification Monitoring and Analysis, Incident Response and Recovery, Cryptography, Network and Communications Security, and Systems and Application Security." },
      { question: "Is SSCP a good entry-level certification?", answer: "Yes, SSCP is an excellent entry-level cybersecurity certification. It requires only 1 year of cumulative paid work experience in one or more of the 7 domains, making it accessible for those starting their cybersecurity career." }
    ],
    cc: [
      { question: "How many questions are on the CC exam?", answer: "The CC exam uses Computerized Adaptive Testing (CAT) with 100-125 questions. You have 2 hours to complete it." },
      { question: "What is the passing score for CC?", answer: "The passing score for the CC exam is 700 out of 1000 points." },
      { question: "What domains does CC cover?", answer: "CC covers 5 domains: Security Principles, Security Governance, Identity and Access Management (IAM) Concepts, Networking and Cloud Security Concepts, and Security Operations and Incident Response." },
      { question: "Do I need experience to take the CC exam?", answer: "No. Certified in Cybersecurity is ISC2's entry-level certification and requires no prior cybersecurity work experience, making it a natural first step toward SSCP and CISSP." }
    ]
  },

  appConfig: {
    logo: '/assets/images/logo.png',

    breadcrumb: [
      { label: 'Home', url: 'https://www.learnzapp.com' },
      { label: 'ISC2 Certifications' }
    ],
    navItems: [
      { label: 'Home', url: '#home' },
      { label: 'Download', url: '#download' },
      { label: 'Features', url: '#features' },
      { label: 'Screenshots', url: '#screenshots' },
      { label: 'Pricing', url: '#pricing' }
    ],
    hero: {
      title: 'Master ISC2 Certifications',
      subtitle1: 'Comprehensive exam preparation for CISSP, CCSP, SSCP and CC certifications with adaptive learning, detailed analytics, and expert-crafted content.',
      subtitle2: 'Start studying smarter today.',
      stats: [
        { value: '10K+', label: 'Active Users', icon: 'users' },
        { value: '95%', label: 'Pass Rate', icon: 'trophy' },
        { value: '5000+', label: 'Practice Questions', icon: 'question-circle' }
      ],
      appIcon: '/assets/images/app-icon.png',
      heroImage: '/assets/images/hero-image.png',
      heroImageDark: '/assets/images/hero-image-dark.png',
    },
    studyAnywhere: {
      title: 'Study Anywhere',
      subtitle: 'Your progress syncs across all your devices - phones, tablets, and web. Start studying on your phone during your commute and continue on your laptop browser at home.',
    },

    downloadLinks: [
      {
        store: 'Apple',
        title: 'App Store',
        url: '#'
      },
      {
        store: 'Google',
        title: 'Google Play',
        url: '#'
      }
    ]
  },

  featuresData: {
    title: 'Everything You Need to Succeed',
    subtitle: 'Comprehensive study tools designed specifically for ISC2 certification success',

    "items": [
      {
        "icon": "chart-line",
        "title": "Readiness Score Analytics",
        "description": "Track your overall readiness and domain-specific performance with detailed analytics. See exactly where you stand and what to focus on next."
      },
      {
        "icon": "file-text",
        "title": "Study Articles & Questions",
        "description": "Expert-written articles covering key exam topics with mapped practice questions. Study the concept, then test your understanding immediately."
      },
      {
        "icon": "tools",
        "title": "Custom Test Builder",
        "description": "Create personalized practice tests by selecting specific domains, difficulty levels, and question counts. Study exactly what you need."
      },
      {
        "icon": "calendar-day",
        "title": "Question of the Day",
        "description": "Build your study streak with daily questions. Track your progress and maintain momentum with just 2 minutes a day."
      },
      {
        "icon": "users",
        "title": "Community Insights",
        "description": "See how other exam candidates answered each question. Learn from the community and understand common mistakes."
      },
      {
        "icon": "sync",
        "title": "Seamless Sync",
        "description": "Study on web, iOS, or Android. Your progress syncs automatically across all devices. Pick up exactly where you left off."
      },
      {
        "icon": "book",
        "title": "Comprehensive Resources",
        "description": "Flashcards, glossary, acronyms, and study guides. Everything you need in one place with regular content updates."
      },
      {
        "icon": "moon",
        "title": "Adaptive Interface",
        "description": "Dark/light mode support and responsive design. Study comfortably any time of day on any device."
      }
    ]
  },

  platforms: [
    {
      icon: 'laptop',
      title: 'Web Platform',
      description: 'Full-featured experience in your browser. Perfect for focused study sessions with detailed analytics.',
      ctaText: 'Sign In to Web App',
      ctaLink: 'https://isc2.learnzapp.com',
    },
    {
      icon: 'mobile-alt',
      title: 'Mobile Apps',
      description: 'Study on-the-go with native iOS and Android apps. Download for offline access and push notifications.',
      ctaText: 'Download Mobile App',
      ctaLink: '#downloads',
    },
    {
      icon: 'bullseye',
      title: 'Diagnostic Test',
      description: 'Not sure where to start? Take our free diagnostic test to assess your current knowledge and get a personalized study plan.',
      ctaText: 'Take Diagnostic Test',
      ctaLink: '#diagnostic',
    },
  ],

  screenshotsData: {
    title: "See It In Action",
    subtitle: "Explore our app's powerful features through these interactive screenshots",
    slides: [
      {
        "id": 1,
        "title": "Home Dashboard for Quick Access",
        "description": "Start studying instantly from the home screen with quick links to questions, tests, flashcards, and custom test creation.",
        "features": [
          "Overall readiness overview",
          "Daily question prompt",
          "Quick access to key study modes"
        ],
        "image": "/assets/images/screenshots/1.png"
      },
      {
        "id": 2,
        "title": "Light & Dark Mode Support",
        "description": "Choose between light and dark themes for comfortable studying in any environment.",
        "features": [
          "Easy theme switching",
          "Eye-friendly design",
          "Optimized for different lighting conditions"
        ],
        "image": "/assets/images/screenshots/2.png"
      },
      {
        "id": 3,
        "title": "Monitor Overall Exam Readiness",
        "description": "View your readiness score across all topics with detailed breakdowns to target weak areas.",
        "features": [
          "Overall readiness score gauge",
          "Topic-wise readiness percentages",
          "Performance history tracking"
        ],
        "image": "/assets/images/screenshots/3.png"
      },
      {
        "id": 4,
        "title": "Create Custom Practice Tests",
        "description": "Build tests tailored to your needs by topic, question count, time limit, and priority type.",
        "features": [
          "Select topics and number of questions",
          "Set time limits",
          "Prioritize incorrect, new, or bookmarked questions"
        ],
        "image": "/assets/images/screenshots/4.png"
      },
      {
        "id": 5,
        "title": "Answer with Confidence",
        "description": "Tackle multiple-choice questions in a clean, distraction-free interface for better focus and accuracy.",
        "features": [
          "Clear question and answer layout",
          "Multiple-choice options",
          "Timer to track pacing"
        ],
        "image": "/assets/images/screenshots/5.png"
      },
      {
        "id": 6,
        "title": "Track Progress in Each Test",
        "description": "Get instant feedback on your performance after each test with accuracy, time per question, and readiness score updates.",
        "features": [
          "Test score and accuracy breakdown",
          "Average time per question",
          "Readiness score improvement tracking"
        ],
        "image": "/assets/images/screenshots/6.png"
      },
      {
        "id": 7,
        "title": "Detailed Answer Explanations",
        "description": "Understand the reasoning behind correct answers with clear, concise explanations after each question.",
        "features": [
          "Highlights correct and incorrect answers",
          "In-depth explanations",
          "Immediate feedback to improve retention"
        ],
        "image": "/assets/images/screenshots/7.png"
      },
      {
        "id": 8,
        "title": "Learn from Community Insights",
        "description": "See how other learners performed on each question and measure your knowledge against the community.",
        "features": [
          "Community score for each question",
          "Percentage range of correct responses",
          "Benchmark your performance"
        ],
        "image": "/assets/images/screenshots/8.png"
      },
      {
        "id": 9,
        "title": "Master Concepts with Flashcards",
        "description": "Reinforce your knowledge using interactive flashcards designed to help you recall definitions and key concepts effortlessly.",
        "features": [
          "Simple question-answer format",
          "Terminology with definitions",
          "Supports quick self-testing"
        ],
        "image": "/assets/images/screenshots/9.png"
      },
      {
        "id": 10,
        "title": "Track Key Terms Easily",
        "description": "Quickly find and understand important certification terms with our searchable glossary for fast and effective learning.",
        "features": [
          "Alphabetical search for terms",
          "Clear, concise definitions",
          "Expandable sections for detailed explanations"
        ],
        "image": "/assets/images/screenshots/10.png"
      }
    ]
  },

  certificationData: {
    title: 'ISC2 Certifications',
    subtitle: 'World-leading cybersecurity certifications',
    items: [
      {
        title: 'ISC2 CISSP',
        domains: [
          'Security and Risk Management',
          'Asset Security',
          'Security Architecture and Engineering',
          'Communication and Network Security',
          'Identity and Access Management',
          'Security Assessment and Testing',
          'Security Operations',
          'Software Development Security'
        ],
        requirements: [
          '5 years cumulative paid work experience in 2+ domains',
          'Pass the CISSP exam',
          'Endorsement by an ISC2 member'
        ],
        experience: '5 years of cumulative paid work experience in two or more of the 8 CISSP domains',
        benefits: [
          'Global recognition',
          'Career advancement',
          'Higher salary potential',
          'DoD 8570 compliance'
        ],
        exam: {
          duration: '3 hours',
          questions: '100-150 questions (CAT)',
          passingScore: '700 out of 1000'
        }
      }
    ]
  },

  contactData: {
    title: 'Contact Us',
    subtitle: 'Have questions? We\'re here to help'
  },

  footerData: {
    logo: '/assets/images/logo.png',
    description: 'Your trusted partner for ISC2 certification exam preparation',
    socialLinks: [{
      url: 'https://www.linkedin.com/company/learnzapp',
      icon: '/assets/images/linkedin-icon.png'
    }],
    examLinksTitle: 'LearnZapp Exam Prep Apps',
    examLinks: [
      {
        name: 'ISC2 Official App',
        details: 'CISSP, CCSP, SSCP and CC',
        icon: '/assets/images/app-icons/isc2.png',
        url: 'https://isc2.learnzapp.com'
      },
      {
        name: 'ISACA Official App',
        details: 'CISA and CISM',
        icon: '/assets/images/app-icons/isaca.png',
        url: 'https://isaca.learnzapp.com'
      },
      {
        name: 'CompTIA Certifications',
        details: '12 CompTIA Exams',
        icon: '/assets/images/app-icons/comptia.png',
        url: 'https://comptia.learnzapp.com'
      }
    ],
    copyright: '© 2024 LearnZapp. All rights reserved.',
    footerLinks: [
      { name: 'Privacy Policy', url: '#' },
      { name: 'Terms of Service', url: '#' },
      { name: 'Contact', url: '#' },
      { name: 'Support', url: '#' }
    ]
  },

  keyStats: {
    items: [
      {
        number: '5000',
        label: 'Study Questions'
      },
      {
        number: '2000',
        label: 'Flashcards'
      },
      {
        number: '2000',
        label: 'Glossary Terms'
      }
    ]
  },

  faqData: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our certification preparation platform',
    faqs: [
      {
        question: 'What certifications do you support?',
        answer: 'We support 4 ISC2 certifications: CISSP (Certified Information Systems Security Professional), CCSP (Certified Cloud Security Professional), SSCP (Systems Security Certified Practitioner), and CC (Certified in Cybersecurity).'
      },
      {
        question: 'How does the adaptive learning system work?',
        answer: 'Our adaptive learning system analyzes your performance across different domains and topics, identifying your strengths and areas for improvement. It then customizes your study plan, focusing on topics where you need more practice while reinforcing your strong areas.'
      },
      {
        question: 'Can I access the platform on multiple devices?',
        answer: 'Yes! Our platform is available on web browsers, iOS, and Android devices. Your progress automatically syncs across all devices, allowing you to study seamlessly whether you\'re at home or on the go.'
      },
      {
        question: 'What\'s included in the subscription plans?',
        answer: 'All subscription plans include access to our complete question bank for all 4 ISC2 exams, study materials, analytics dashboard, and practice tests. Longer-term plans offer additional savings and may include premium features like detailed performance analytics and personalized study recommendations.'
      },
      {
        question: 'How often is the content updated?',
        answer: 'We regularly update our content to align with the latest exam changes and industry best practices. Our team of certified professionals reviews and updates questions and study materials to ensure they reflect current exam requirements and industry standards.'
      },
      {
        question: 'Do you offer a money-back guarantee?',
        answer: 'Yes, we offer a 7-day money-back guarantee for our subscription plans. If you\'re not satisfied with our platform, you can request a full refund within the first 7 days of your subscription.'
      }
    ]
  }
};
